import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbTipoEventoPsim } from 'app/abstract/full-pages/tipo-evento-psim/tipo-evento-psim.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TipoEventoPsimService extends AbTipoEventoPsim {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllNotificacao(filter: AppFilter): Observable<any> {
    return this.get(`notificacao_tipo_evento/filter/${filter.encode()}`);
  }

  public deleteNotificacao(entityId: number) {
    return this.delete('notificacao_tipo_evento/', entityId);
  }

  public getAllTipoNotificacaoBySitemaPsim(sistemaPsim): Observable<any> {
    return this.get(`tipo_evento_psim/sistema_psim/${sistemaPsim}`);
  }

  public saveNotificacoes(notificacoes): Observable<any> {
    return this.save('notificacao_tipo_evento/', notificacoes);
  }

  public getNotificacao(id): Observable<any> {
    return this.get(`notificacao_tipo_evento/dto/${id}`);
  }

}
